import { getProp } from './props'
import { getCharacter, type CharacterDef } from './characters'

export interface AggregatedEffects {
  coinMult: number
  scoreMult: number
  magnetRadius: number
  visionRange: number
  oneHitShield: boolean
  slowmoTint: boolean
  slideSpeedMult: number
}

export const BASE_EFFECTS: AggregatedEffects = {
  coinMult: 1,
  scoreMult: 1,
  magnetRadius: 0,
  visionRange: 0,
  oneHitShield: false,
  slowmoTint: false,
  slideSpeedMult: 1,
}

export function aggregateEffects(propIds: string[], character?: CharacterDef | string): AggregatedEffects {
  const out: AggregatedEffects = { ...BASE_EFFECTS }
  const seenSlots = new Set<string>()

  for (const id of propIds) {
    const prop = getProp(id)
    if (!prop) continue
    if (seenSlots.has(prop.slot)) continue
    seenSlots.add(prop.slot)
    for (const fx of prop.effects) {
      switch (fx.kind) {
        case 'coinMult':
          out.coinMult *= fx.value
          break
        case 'scoreMult':
          out.scoreMult *= fx.value
          break
        case 'magnet':
          out.magnetRadius = Math.max(out.magnetRadius, fx.value)
          break
        case 'vision':
          out.visionRange = Math.max(out.visionRange, fx.value)
          break
        case 'shield':
          out.oneHitShield = true
          break
        case 'slowmo':
          out.slowmoTint = true
          break
        case 'speed':
          out.slideSpeedMult *= fx.value
          break
        case 'flavor':
          break
      }
    }
  }

  const char = typeof character === 'string' ? getCharacter(character) : character
  if (char) {
    for (const ability of char.abilities) {
      switch (ability) {
        case 'speed':
          out.slideSpeedMult *= 1.15
          break
        case 'shield':
          out.oneHitShield = true
          break
        case 'magnet':
          out.magnetRadius = Math.max(out.magnetRadius, 1)
          break
        case 'time_slow':
          out.slowmoTint = true
          break
        case 'health_regen':
          out.scoreMult *= 1.1
          break
        case 'double_jump':
          break
      }
    }
  }

  out.coinMult = Math.round(out.coinMult * 100) / 100
  out.scoreMult = Math.round(out.scoreMult * 100) / 100
  out.slideSpeedMult = Math.min(2, Math.round(out.slideSpeedMult * 100) / 100)
  return out
}
